var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"years-container"},_vm._l((_vm.years),function(year,m){return _c('YourPlanColumn',{key:m,attrs:{"title":year.title,"sections":year.sections},on:{"selectSection":function($event){return _vm.onSelectSection($event, year.title)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }